/**
 * @generated SignedSource<<004634462eadbe16170d347093dcc373>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileEditScreenQuery$variables = Record<PropertyKey, never>;
export type ProfileEditScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProfileEditView_query">;
};
export type ProfileEditScreenQuery = {
  response: ProfileEditScreenQuery$data;
  variables: ProfileEditScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v1/*:: as any*/),
  (v3/*:: as any*/)
],
v5 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/),
  (v3/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileEditScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ProfileEditView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "GenderConnection",
        "kind": "LinkedField",
        "name": "genders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Gender",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOther",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "genders(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "beliefSystemId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "biography",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "childrenPreferenceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closestCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "educationLevelId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genderOther",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightCm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightFt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagram",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occupation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "politicalViewId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pronounId",
                "storageKey": null
              },
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "school",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vaccinationStatusId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "activities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v4/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BeliefSystem",
                "kind": "LinkedField",
                "name": "beliefSystem",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChildrenPreference",
                "kind": "LinkedField",
                "name": "childrenPreference",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DeetConnection",
                "kind": "LinkedField",
                "name": "deets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Deet",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v4/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EducationLevel",
                "kind": "LinkedField",
                "name": "educationLevel",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Gender",
                "kind": "LinkedField",
                "name": "gender",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PoliticalView",
                "kind": "LinkedField",
                "name": "politicalView",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Pronoun",
                "kind": "LinkedField",
                "name": "pronoun",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VaccinationStatus",
                "kind": "LinkedField",
                "name": "vaccinationStatus",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "BeliefSystemConnection",
        "kind": "LinkedField",
        "name": "beliefSystems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeliefSystem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "beliefSystems(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "ChildrenPreferenceConnection",
        "kind": "LinkedField",
        "name": "childrenPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChildrenPreference",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "childrenPreferences(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EducationLevelConnection",
        "kind": "LinkedField",
        "name": "educationLevels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EducationLevel",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "educationLevels(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "PoliticalViewConnection",
        "kind": "LinkedField",
        "name": "politicalViews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticalView",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "politicalViews(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "PronounConnection",
        "kind": "LinkedField",
        "name": "pronouns",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pronoun",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "pronouns(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "VaccinationStatusConnection",
        "kind": "LinkedField",
        "name": "vaccinationStatuses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VaccinationStatus",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": "vaccinationStatuses(orderBy:[\"SEQUENCE_ASC\"])"
      }
    ]
  },
  "params": {
    "cacheID": "266263012bb2abac0def10d115a0e2e5",
    "id": null,
    "metadata": {},
    "name": "ProfileEditScreenQuery",
    "operationKind": "query",
    "text": "query ProfileEditScreenQuery {\n  ...ProfileEditView_query\n}\n\nfragment BeliefSystemSelectInput_query on Query {\n  beliefSystems(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment ChildrenPreferenceSelectInput_query on Query {\n  childrenPreferences(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment EducationLevelSelectInput_query on Query {\n  educationLevels(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment GenderSelectInput_query on Query {\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment HeightInput_query on Query {\n  currentUser {\n    isMetricSystem\n    id\n  }\n}\n\nfragment OwnProfileInfo_profile on Profile {\n  activities {\n    nodes {\n      name\n      id\n    }\n  }\n  age\n  beliefSystem {\n    name\n    id\n  }\n  biography\n  childrenPreference {\n    name\n    id\n  }\n  closestCity\n  deets {\n    nodes {\n      name\n      id\n    }\n  }\n  educationLevel {\n    name\n    id\n  }\n  gender {\n    name\n    id\n  }\n  genderOther\n  heightCm\n  heightFt\n  heightIn\n  occupation\n  politicalView {\n    name\n    id\n  }\n  pronoun {\n    name\n    id\n  }\n  school\n  userId\n  vaccinationStatus {\n    name\n    id\n  }\n}\n\nfragment PoliticalViewSelectInput_query on Query {\n  politicalViews(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment ProfileEditView_query on Query {\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n  ...useProfile_query\n  ...BeliefSystemSelectInput_query\n  ...ChildrenPreferenceSelectInput_query\n  ...EducationLevelSelectInput_query\n  ...GenderSelectInput_query\n  ...HeightInput_query\n  ...PoliticalViewSelectInput_query\n  ...PronounSelectInput_query\n  ...VaccinationStatusSelectInput_query\n}\n\nfragment PronounSelectInput_query on Query {\n  pronouns(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment VaccinationStatusSelectInput_query on Query {\n  vaccinationStatuses(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment useProfile_query on Query {\n  currentUser {\n    profile {\n      beliefSystemId\n      biography\n      childrenPreferenceId\n      closestCity\n      educationLevelId\n      genderId\n      genderOther\n      heightCm\n      heightFt\n      heightIn\n      instagram\n      occupation\n      politicalViewId\n      pronounId\n      rowId\n      school\n      vaccinationStatusId\n      ...OwnProfileInfo_profile\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "647ca19468c62f01f6ab9ad72d634bdd";

export default node;
